class PlannerConfiguration {

    constructor(brand, serverUrl) {
        this.brand = brand;
        this.serverUrl = serverUrl;
        this.app = appConfig;
        let body = $('body');
        this.debugMode = body.hasClass('debugMode');
        this.debugPersistData = body.hasClass('debugPersistData');
    }
}

let _planner_configuration = null;

function getPlannerConfiguration() {
    if(_planner_configuration == null) {
        const body = $('body');
        const brand = body.attr('data-brand');
        const serverUrl = body.attr('data-server-url');
        return new PlannerConfiguration(brand, serverUrl);
    }
    return _planner_configuration;
}
